import React, { useState, useEffect } from "react";
import MediaSelector from "./MediaSelector";

const ExampleUsage = () => {
  const [mediaType, setMediaType] = useState("video");

  const handleSelection = (selectedItems) => {
    console.log("Selected items:", selectedItems);
    // Do something with the selected items
  };

  return (
    <MediaSelector
      type={mediaType} // or "video" or "all"
      selection="single" // or "single"
      selectionLimit={1}
      onSelected={handleSelection}
    />
  );
};

export default ExampleUsage;
